

















import { Vue, Component } from 'vue-property-decorator';
import Add from '@/views/system/settings/menu/unit/add.vue';
import MenuComponent from '@/views/system/settings/menu/unit/menuComponent.vue';

@Component({
  components: { MenuComponent, Add },
})
export default class User extends Vue {
  showFlag = 1; // 控制显示的组件
  row: any = ''; // 传递一行的值
  /**
   * @todo 后期需要优化的部分
   * @desc 自定义事件，得到要修改一行的数据。
   * @param state - 模板状态 1-开始状态 2-结束状态
   * @returns 返回值描述
   */
  getRow(row: string) {
    this.row = row;
  }
}
